/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component } from '@angular/core';
import { I18nService } from '@dm/core';

@Component({
    selector: 'app-error-404',
    templateUrl: './error-404.component.html',
    styleUrls: ['./error-404.component.scss'],
})

export class Error404Component {
    constructor(
        public i18n: I18nService,
    ) { }
}
